export default {
  titleObj: {
    setEmail: {
      titleName: 'メールアドレスを入力してください',
      percentNum: 0,
    },
    setEmail_byorther: {
      titleName: 'メールアドレスを入力してください',
      percentNum: 0,
    },
    authenticationCode: {
      titleName: '認証コードを入力してください',
      percentNum: 0,
    },
    applyTypeChoose: {
      titleName: '個人のお申込みですか？法人のお申込みですか？',
      percentNum: 3,
    },
    condition: {
      titleName: '下記の条件に該当しないことをご確認ください',
      percentNum: 3,
    },
    nameBirthdaySex: {
      titleName: 'お名前と生年月日と性別を入力してください',
      percentNum: 6,
    },
    underAgeInfo: {
      titleName: '親権者の情報を入力してください',
      percentNum: 6,
    },
    nationalty: {
      titleName: '国籍を選択してください',
      percentNum: 10,
    },
    address: {
      titleName: '住所を入力してください',
      percentNum: 13,
    },
    IsSameNowAddress: {
      titleName: '住所を入力してください',
      percentNum: 13,
    },
    nowAddress: {
      titleName: '2021年1月1日時点での住所を入力してください',
      percentNum: 13,
    },
    tel: {
      titleName: 'ご連絡先を入力してください',
      percentNum: 16,
    },
    financialBank: {
      titleName: '出金先の金融機関を設定してください',
      percentNum: 20,
    },
    occupationType: {
      titleName: '職業を選択してください',
      percentNum: 23,
    },
    schoolName: {
      titleName: '勤務先を入力してください',
      percentNum: 26,
    },
    employmentAddress: {
      titleName: '勤務先・学校の住所を 入力してください',
      percentNum: 26,
    },
    employmentName: {
      titleName: '勤務先名を入力してください',
      percentNum: 26,
    },
    employmentTel: {
      titleName: '勤務先・学校の電話番号を入力してください',
      percentNum: 33,
    },
    insiderFlg: {
      titleName: 'お客様は内部者に該当しますか？',
      percentNum: 30,
    },
    fundInsiderFlg: {
      titleName: '内部者登録について',
      percentNum: 30,
    },

    insiderSeparation: {
      titleName: '内部者に該当する会社の種類を選択してください',
      percentNum: 30,
    },
    insiderInfo: {
      titleName: '内部関係者区分と、会社の銘柄コードを入力してください',
      percentNum: 30,
    },
    questionMotiveType: {
      titleName: 'お申込みの動機を選択してください',
      percentNum: 33,
    },
    purpose: {
      titleName: '投資の目的を選択してください',
      percentNum: 36,
    },
    annualIncome: {
      titleName: '年収を選択してください',
      percentNum: 40,
    },
    revenue: {
      titleName: '主な収入の種類を選択してください',
      percentNum: 43,
    },
    financialAssts: {
      titleName: '金融資産額を選択してください',
      percentNum: 46,
    },
    asstsType: {
      titleName: '投資資金は余裕資金ですか',
      percentNum: 50,
    },
    experienceStock: {
      titleName: '現物株式取引の投資経験を選択してください',
      percentNum: 53,
    },
    experienceDerivative: {
      titleName: 'デリバティブ取引の投資経験を選択してください',
      percentNum: 56,
    },
    experienceFund: {
      titleName: '投資信託・債券・貴金属取引の投資経験を選択してください',
      percentNum: 60,
    },
    desiredInvestmentType: {
      titleName: '興味のある投資商品を選択してください',
      percentNum: 63,
    },
    electronic: {
      titleName: '電子交付等に関する説明書をご確認ください',
      percentNum: 66,
    },
    personalInfo: {
      titleName: '個人情報保護方針をご確認ください',
      percentNum: 68,
    },
    antisocialFlg: {
      titleName: '反社会的勢力でないことの確約に関する同意書をご確認ください',
      percentNum: 70,
    },
    regulation: {
      titleName: '約款・規程集 契約締結前交付書面をご確認ください',
      percentNum: 73,
    },
    loginPassword: {
      titleName: 'ログインパスワードを設定してください',
      percentNum: 76,
    },
    isEmailSend: {
      titleName: 'メール配信についてご確認ください',
      percentNum: 80,
    },
    confirmInfo: {
      titleName: 'お申込み内容をご確認ください',
      percentNum: 83,
    },
    submitconfirm: {
      titleName: '続けて、マイナンバーと本人確認書類のご提出へお進みください',
      percentNum: 86,
    },
    identityDocumentsType: {
      titleName: '書類をご用意ください',
      percentNum: 90,
    },
    identityDocumentsTypeForeign: {
      titleName: '本人確認書類をご用意ください',
      percentNum: 90,
    },
    myNumber: {
      titleName: 'マイナンバーを入力してください',
      percentNum: 93,
    },
    myNumberUpload: {
      titleName: 'マイナンバー確認書類をアップロードしてください',
      percentNum: 93,
    },
    documentUpload: {
      titleName: '続柄確認書類をアップロードしてください',
      percentNum: 96,
    },
    onlineConfirm: {
      titleName: '続いて、2.ご本人確認へお進みください',
      percentNum: 99,
    },
    'Register/Over': {
      titleName: '口座開設を受付けました',
      percentNum: 100,
    },

    // 法人
    corporateNameNumber: {
      titleName: '法人名と法人番号を入力してください',
      percentNum: 3,
    },
    corporateListType: {
      titleName: '上場区分を選択してください',
      percentNum: 5,
    },
    corporateAddress: {
      titleName: '所在地を入力してください',
      percentNum: 7,
    },
    representativeTel: {
      titleName: '代表の連絡先を入力してください',
      percentNum: 10,
    },
    businessContent: {
      titleName: '事業内容を選択してください',
      percentNum: 13,
    },
    capitalTaxType: {
      titleName: '税制区分と資本金を選択してください',
      percentNum: 15,
    },
    dateOfEstablishment: {
      titleName: '設立年月日と本決算日を入力してください',
      percentNum: 17,
    },
    representativeInfo: {
      titleName: '代表者情報を入力してください',
      percentNum: 20,
    },
    transactionManager: {
      titleName: '取引責任者情報を入力してください',
      percentNum: 23,
    },
    corporateInsiderFlg: {
      titleName: '取引責任者は内部者に該当しますか？',
      percentNum: 25,
    },
    corporateFundInsiderFlg: {
      titleName: '内部者登録について',
      percentNum: 25,
    },
    listedCorporationFlg: {
      titleName: '上場企業や国等への該当性を選択してください',
      percentNum: 27,
    },
    specifiedCorporationFlg: {
      titleName: '特定法人への該当性を選択してください',
      percentNum: 35,
    },
    rulerInfo: {
      titleName: '実質的支配者の情報を入力してください',
      percentNum: 30,
    },

    corporateWithdrawAccount: {
      titleName: '出金先の金融機関を設定してください',
      percentNum: 43,
    },
    corporateQuestionMotiveType: {
      titleName: 'お申込みの動機を選択してください',
      percentNum: 45,
    },
    corporatePurpose: {
      titleName: '投資の目的を選択してください',
      percentNum: 47,
    },
    corporateFinancialAssts: {
      titleName: '投資する予定の金額を入力してください',
      percentNum: 50,
    },
    corporateAsstsType: {
      titleName: '投資資金は余裕資金ですか',
      percentNum: 53,
    },
    corporateExperienceStock: {
      titleName: '現物株式取引の投資経験を選択してください',
      percentNum: 55,
    },
    corporateExperienceDerivative: {
      titleName: 'デリバティブ取引の投資経験を選択してください',
      percentNum: 57,
    },
    corporateExperienceFund: {
      titleName: '投資信託・債券・貴金属取引の投資経験を選択してください',
      percentNum: 60,
    },
    corporateDesiredInvestmentType: {
      titleName: '興味のある投資商品を選択してください',
      percentNum: 63,
    },
    corporateElectronicDelivery: {
      titleName: '電子交付等に関する説明書をご確認ください',
      percentNum: 65,
    },
    corporatePersonalInfo: {
      titleName: '個人情報保護方針をご確認ください',
      percentNum: 66,
    },
    corporateAntisocialFlg: {
      titleName: '反社会的勢力でないことの確約に関する同意書をご確認ください',
      percentNum: 67,
    },
    corporateRegulation: {
      titleName: '約款·規程集 契約締結前交付書面をご確認ください',
      percentNum: 70,
    },
    foreignCountryCompany: {
      titleName: '下記の条件に該当しないことをご確認ください',
      percentNum: 3,
    },
    corporateLoginPassword: {
      titleName: 'ログインパスワードを設定してください',
      percentNum: 73,
    },
    corporateisEmailSend: {
      titleName: 'メール配信についてご確認ください',
      percentNum: 75,
    },
    corporateConfirmInfo: {
      titleName: 'お申込み内容をご確認ください',
      percentNum: 77,
    },
    corporateidentificationGuide: {
      titleName: '続けて、確認書類のご提出へお進みください',
      percentNum: 80,
    },
    corporateCertificateUpload: {
      titleName: '法人確認書類をアップロードしてください',
      percentNum: 83,
    },
    representativeIdentityDocumentsType: {
      titleName: '代表者の本人確認書類の種類を選択してください',
      percentNum: 85,
    },
    representativeIdentityDocumentsUpload: {
      titleName: '代表者の本人確認書類をアップロードしてください',
      percentNum: 87,
    },
    transactionManagerIdentityDocumentsType: {
      titleName: '取引責任者の本人確認書類の種類を選択してください',
      percentNum: 90,
    },
    transactionManagerIdentityDocumentsUpload: {
      titleName: '取引責任者の本人確認書類をアップロードしてください',
      percentNum: 93,
    },
    rulerIdentityDocumentsType: {
      titleName: '実質的支配者の本人確認書類の種類を選択してください',
      percentNum: 95,
    },
    rulerIdentityDocumentsUpload: {
      titleName: '実質的支配者の本人確認書類をアップロードしてください',
      percentNum: 95,
    },
    /*再提出界面*/
    certifyEmail: {
      titleName: 'メールアドレスを入力してください',
      percentNum: 90,
    },
    resetEmail: {
      titleName: 'メールアドレスを入力してください',
      percentNum: 0,
    },
    //个人再提出界面
    resetConfirmInfo: {
      titleName: 'お申込み内容をご確認ください',
      percentNum: 83,
    },
    resetNameBirthdaySex: {
      titleName: 'お名前と生年月日と性別を入力してください',
      percentNum: 6,
    },
    resetNationalty: {
      titleName: '国籍を選択してください',
      percentNum: 10,
    },
    resetAddress: {
      titleName: '住所を入力してください',
      percentNum: 13,
    },
    resetTel: {
      titleName: 'ご連絡を入力してください',
      percentNum: 16,
    },
    resetIdentityType: {
      titleName: '書類をご用意ください',
      percentNum: 90,
    },
    resetMyNumber: {
      titleName: 'マイナンバーを入力してください',
      percentNum: 93,
    },
    resetMyNumberUpload: {
      titleName: 'マイナンバー確認書類をアップロードしてください',
      percentNum: 93,
    },
    resetOnlineConfirm: {
      titleName: '続いて、2.ご本人確認へお進みください',
      percentNum: 99,
    },
    'Register/resetOver': {
      titleName: '再提出を受付けました',
      percentNum: 100,
    },
    // 法人再提出
    corporateResetConfirmInfo: {
      titleName: 'お申込み内容をご確認ください',
      percentNum: 77,
    },
    resetCertificateUpload: {
      titleName: '法人確認書類をアップロードしてください',
      percentNum: 83,
    },
    resetRepresentType: {
      titleName: '代表者の本人確認書類の種類を選択してください',
      percentNum: 85,
    },
    resetRepresentUpload: {
      titleName: '代表者の本人確認書類をアップロ ードしてください',
      percentNum: 87,
    },
    resetTransactionManagerType: {
      titleName: '取引責任者の本人確認書類の種類 を選択してください',
      percentNum: 90,
    },
    resetTransactionManagerUpload: {
      titleName: '取引責任者の本人確認書類をアッ プロードしてください',
      percentNum: 93,
    },
    resetRulerTypeUpload: {
      titleName: '実質的支配者の本人確認書類をア ップロードしてください',
      percentNum: 95,
    },
    'reset/confirmInfo': {
      titleName: 'お申し込み内容をご確認ください',
      percentNum: 95,
    },
    'reset/nameBirthdaySex': {
      titleName: 'お名前と生年月日と性別を入力してください',
      percentNum: 95,
    },
    'reset/address': {
      titleName: '住所を入力してください',
      percentNum: 95,
    },
    'reset/tel': {
      titleName: '電話番号を入力してください',
      percentNum: 95,
    },
    'reset/identityDocumentsType': {
      titleName: '書類をご用意ください',
      percentNum: 90,
    },
    'reset/myNumberUpload': {
      titleName: 'マイナンバー確認書類をアップロードしてください',
      percentNum: 93,
    },
    'reset/onlineConfirm': {
      titleName: '続いて、2.ご本人確認へお進みください',
      percentNum: 99,
    },
    'resetOver': {
      titleName: '再提出を受付けました',
      percentNum: 100,
    },
    documentVerifySetEmail:{
      titleName: '書類提出とご本人確認',
      percentNum: 90
    }
    /*    restSelfConfirm: {
          titleName: 'マイナンバー確認書類をアップロードしてください',
          percentNum: 93,
        },*/
  }
}




// WEBPACK FOOTER //
// ./src/utils/contentItem.js